<template>
  <span v-if="showNav">
        <a
            :aria-expanded="entitlementsCollaps"
            class="sidebar-menu-item nav-link"
            data-toggle="collapse"
            @click="entitlementsCollaps=!entitlementsCollaps"
        >
            <template>
                <i class="fa pr-2 fa-signal text-blue"></i>
                <span class="nav-link-text">Entitlements <b class="caret"></b></span>
            </template>
        </a>
        <collapse-transition :duration="{enter: 500, leave: 500}">
            <div v-show="entitlementsCollaps" id="collapse-just1" :class="entitlementsCollaps?'show':''" class="collapse collapse-just">
                <ul class="nav nav-sm flex-column">
                    <slot name="title">
                        <router-link
                            :target="link.target"
                            class="nav-link"
                            href="/entitlements"
                            to="/entitlements"
                            @click.native="linkClick"
                        >
                            <template>
                                <i class="fa fa-folder-open text-green pr-2"></i>
                                <span class="nav-link-text">Manager</span>
                            </template>
                        </router-link>

                    </slot>
                </ul>
            </div>
        </collapse-transition>
    </span>
</template>
<script>
import {CollapseTransition} from "vue2-transitions";
import initService from "../../../common/api-services/init-service";

export default {
  name: 'side-entitlements-group',
  components: {
    CollapseTransition
  },
  data() {
    return {

      isPortalAdminStatus: false,
      isAdminStatus: false,
      groups: [],
      showNav: false,

      entitlementsCollaps: false,
      link: {
        name: '',
        icon: '',
        path: '',
        children: []
      },
      navPermissions: {
        "authGroup": {
          enable: false,
          role: ["Administrator","CARRIER_ADMIN","ENTITLEMENTS_ADMIN","ENTITLEMENTS_EDIT","ENTITLEMENTS_READ"]
        },
      }
    }
  },
  mounted() {
    this.isPortalAdminStatus = initService.getPortalAdminRole();
    this.isAdminStatus = initService.getAdministratorRole() || initService.getPortalAdminRole();
    this.groups = initService.getGroups();
    Object.keys(this.navPermissions).map(item => {
      this.groups.map(it => {
        if (this.navPermissions[item].role.includes(it)) {
          this.navPermissions[item].enable = true;
          this.showNav = true;
        }
      });
    });
  },
  methods: {
    linkClick() {
      if (
          this.autoClose &&
          this.$sidebar &&
          this.$sidebar.showSidebar === true
      ) {
        this.$sidebar.displaySidebar(false);
      }
    },
  }
}
</script>
